import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  return {
    article: {
      maxWidth: 900,
    },
    helpArticleFigure: {
      backgroundColor: '#ffffff',
      border: '1px solid #ffffff',
      boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.15)',
      margin: '2rem 0',
      '& img': {
        maxWidth: '100%',
        height: 'auto',
      },
      '& figcaption': {
        fontSize: '0.85rem',
        fontStyle: 'italic',
        padding: '0.5rem 1.5rem 1rem',
      },
    },
    code: {
      display: 'block',
      marginTop: '15px',
      padding: '17px 20px 20px',
      border: '1px solid #e5e8ec',
      background: '#fbfdff',
      whiteSpace: 'pre-wrap',
      fontSize: '80%',
    },
    articleList: {
      paddingLeft: 40,
    },
    articleInnerList: {
      paddingLeft: 20,
    },
    link: {
      textDecoration: 'underline',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  }
})
